import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import debit from "../../assets/image/png/debit.png";
import visa from "../../assets/image/png/visa.png";
import applepay from "../../assets/image/png/applepay.png";
import americanexpress from "../../assets/image/png/americanexpress.png";
import paypal from "../../assets/image/png/paypal.png";
import arrowback from "../../assets/image/png/arrow_back.png";
import lock from "../../assets/image/png/lock.png";
import delivery from "../../assets/image/png/deliveryicon.png";
import message from "../../assets/image/png/message.png";
import Navbar from "../homepage/Navbar";
import { Footer } from "../../shared";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import AddressModal from "../address/AddressModal";
import phonepay from "../../assets/image/svg/phonepelogo.svg";
import razorpay from "../../assets/image/png/razorpay-icon1.png";
import ConfirmationModal from "../Confirmation/ConfirmationModal";
import { createOrder, createOrderr } from "../../services/CartServices";
import { useDispatch } from "react-redux";
import {
  emptyCartCount,
  handleChangeCartCount,
} from "../../redux/slice/userSlice";
import LockIcon from "@mui/icons-material/Lock";
import MessageIcon from "@mui/icons-material/Message";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { Header } from "../../shared";

const Cart = () => {
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [allItems, setAllItems] = useState([]);
  const [isAddAddressModal, setIsAddAddressModal] = useState(false);
  const [isEditAddressModal, setIsEditAddressModal] = useState(false);
  const [isConfirmationPopup, setIsConfirmationPopup] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("online");
  const [paymentGateway, setPaymentGateway] = useState("phonepe");
  const [amounts, setAmounts] = useState({
    subtotal: 0,
    discount: 0,
    tax: 14, // This could be used if you want to show the default tax before applying GST/HGST
    total: 0,
    gstLabel: "GST",
    gstAmount: 0,
    platformFee: 1,
  });
  const { subtotal, discount, tax, total, gstLabel, gstAmount, platformFee } =
    amounts;
  const [delievery, setDelievery] = useState([]);
  const navigate = useNavigate();
  const [addAddressData, setAddAddressData] = useState({
    name: "",
    address: "",
    city: "",
    country: "",
    pincode: "",
    state: "",
    phoneNumber: "",
  });
  const [editAddressData, setEditAddressData] = useState({
    name: "",
    address: "",
    city: "",
    country: "",
    pincode: "",
    state: "",
    phoneNumber: "",
    id: "",
  });
  const [allAddress, setAllAddress] = useState([]);
  const { address, city, country, name, pincode, state, phoneNumber } =
    addAddressData;
  const [currentAddress, setCurrentAddress] = useState({
    index: null,
    address: {},
  });

  const handleAddressChange = (type, e) => {
    const { name, value } = e.target;

    // Validate based on the type of input
    if (name === "phoneNumber") {
      // Only allow up to 10 digits and numeric input
      if (value.length <= 10 && /^[0-9]*$/.test(value)) {
        if (type === 1) {
          setAddAddressData({ ...addAddressData, [name]: value });
        } else if (type === 2) {
          setEditAddressData({ ...editAddressData, [name]: value });
        }
      }
    } else if (name === "pincode") {
      // Only allow up to 6 digits and numeric input
      if (value.length <= 6 && /^[0-9]*$/.test(value)) {
        if (type === 1) {
          setAddAddressData({ ...addAddressData, [name]: value });
        } else if (type === 2) {
          setEditAddressData({ ...editAddressData, [name]: value });
        }
      }
    } else {
      // Handle other inputs normally
      if (type === 1) {
        setAddAddressData({ ...addAddressData, [name]: value });
      } else if (type === 2) {
        setEditAddressData({ ...editAddressData, [name]: value });
      }
    }
  };

  const handleAddAddress = async () => {
    if (!name) {
      return toast.error("Name is Required");
    }
    if (!phoneNumber) {
      return toast.error("Phone Number is Required");
    }
    if (!address) {
      return toast.error("Address is Required");
    }
    if (!city) {
      return toast.error("City is Required");
    }
    if (!country) {
      return toast.error("Country is Required");
    }
    if (!pincode) {
      return toast.error("Pin Code is Required");
    }
    if (!state) {
      return toast.error("State is Required");
    }

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/addAddress",
      {
        address,
        city,
        country,
        name,
        pincode,
        state,
        phoneNumber,
      },
      {
        headers: {
          token: Cookies.get("token"),
        },
      },
    );
    if (response?.data?.status === "success") {
      setAllAddress([...allAddress, response?.data?.data]);

      // Keep address unselected after adding a new address
      setCurrentAddress({
        index: null,
        address: {},
      });
      setIsAddAddressModal(false);
      setAddAddressData({
        name: "",
        address: "",
        city: "",
        country: "",
        pincode: "",
        state: "",
        phoneNumber: "",
      });
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.data?.message);
    }
  };

  const handleEditAddress = async () => {
    if (!editAddressData.name) {
      return toast.error("Name is Required");
    }
    if (!editAddressData.phoneNumber) {
      return toast.error("Phone Number is Required");
    }
    if (!editAddressData.address) {
      return toast.error("Address is Required");
    }
    if (!editAddressData.city) {
      return toast.error("City is Required");
    }
    if (!editAddressData.country) {
      return toast.error("Country is Required");
    }
    if (!editAddressData.pincode) {
      return toast.error("Pin Code is Required");
    }
    if (!editAddressData.state) {
      return toast.error("State is Required");
    }

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/updateAddress",
      {
        address: editAddressData?.address,
        city: editAddressData?.city,
        country: editAddressData?.country,
        name: editAddressData?.name,
        pincode: editAddressData?.pincode,
        state: editAddressData?.state,
        phoneNumber: editAddressData?.phoneNumber,
        addressId: editAddressData?.id,
      },
      {
        headers: {
          token: Cookies.get("token"),
        },
      },
    );
    if (response?.data?.status === "success") {
      const indexToUpdate = allAddress.findIndex(
        (item) => item._id === editAddressData?.id,
      );
      const newData = [...allAddress];
      newData[indexToUpdate] = { ...response?.data?.data };
      setAllAddress(newData);
      setIsEditAddressModal(false);
      setCurrentAddress({
        index: null,
        address: {},
      });
      setEditAddressData({
        name: "",
        address: "",
        city: "",
        country: "",
        pincode: "",
        state: "",
        phoneNumber: "",
      });
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.data?.message);
    }
  };

  const handleRemoveItem = async (id = null) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/removeFromCart",
      { droneId: id, droneIdd: id, type: id === null ? "deleteAll" : "" },
      {
        headers: {
          token: Cookies.get("token"),
        },
      },
    );
    if (response?.data?.status === "success") {
      if (id === null) {
        dispatch(emptyCartCount());
        setAllItems([]);
        handleAmounts([]);
        return;
      }
      let updatedItems = allItems.filter((item) => item._id !== id);
      setAllItems(updatedItems);
      handleAmounts(updatedItems);
      dispatch(handleChangeCartCount(-1));
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.data?.message);
    }
  };

  const handleRemoveAddress = async (id) => {
  const response = await axios.post(
    process.env.REACT_APP_API_URL + "/deleteAddress",
    { addressId: id },
    {
      headers: {
        token: Cookies.get("token"),
      },
    },
  );

  if (response?.data?.status === "success") {
    const updatedAddress = allAddress.filter(
      (item) => item._id !== id
    );

    setAllAddress(updatedAddress);

    // Always keep address unselected
    setCurrentAddress({
      index: null,
      address: {},
    });

    toast.success(response?.data?.message);
  } else {
    toast.error(response?.data?.message);
  }
};

  const handleGetAllItems = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/getAllItemsFromCart",
      {
        headers: {
          token: Cookies.get("token"),
        },
      },
    );
    if (response?.data?.status === "success") {
      const items = response.data.data;
      // Extract deliveryFee from the first item, default to 500 if undefined
      const deliveryFee =
        items.length > 0 ? items[0].detail.delieveryFee || 500 : 500;
      setDelievery(deliveryFee);
      setAllItems(response.data.data);
      handleAmounts(items);
    } else {
      toast.error(response?.data?.message);
    }
  };

  const getAllAddress = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/getAllAddress",
      {
        headers: {
          token: Cookies.get("token"),
        },
      },
    );
    if (response?.data?.status === "success") {
      setAllAddress(response.data.data);
    } else {
      toast.error(response?.data?.message);
    }
  };

  const handleUpdateQuantity = async (id, quantity) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/updateQuantity",
      { droneId: id, quantity },
      {
        headers: {
          token: Cookies.get("token"),
        },
      },
    );
    if (response?.data?.status === "success") {
      const updatedItems = allItems.map((item) =>
        item._id === id ? { ...item, quantity: quantity } : item,
      );
      setAllItems(updatedItems);
      handleAmounts(updatedItems);
    } else {
      toast.error(response?.data?.message);
    }
  };
  const handleAmounts = (items, userAddress, manufacturerState) => {
    // If cart is empty, set all values to 0
    if (!items || items.length === 0) {
      setAmounts({
        subtotal: 0,
        discountAmount: 0,
        total: 0,
        gstAmount: 0,
        gstLabel: "GST",
        platformFee: 0,
        delievery: 0,
      });
      return;
    }

    let subtotal = 0; // Initialize subtotal as 0
    let discountAmount = 0; // Initialize discount amount as 0
    let totalDeliveryFee = 0;

    // Loop through each item in the cart
    items.forEach((item) => {
      // Check if the item is a drone part
      const isDronePart = item.type === "dronePart";

      // Get the regular price and discount price from the item details
      const price = item.detail.price || 0; // Default to 0 if no price is found
      const discountPrice = item.detail.discountPrice || price; // Fallback to regular price if discount price is not available
      const delivery = item.detail.delieveryFee;

      // For drone parts, use discountPrice; otherwise, use regular price
      const itemPrice = isDronePart ? discountPrice : price;

      // Calculate the subtotal by adding the item price multiplied by the quantity
      subtotal += itemPrice * item.quantity;

      // If delivery is undefined or null, add 500 to the delivery fee
      if (delivery == null) {
        totalDeliveryFee += 500 * item.quantity; // Add 500 for each item
      } else {
        totalDeliveryFee += delivery * item.quantity; // Use the map value if available
      }

      // If it's a drone part with a discount, calculate the total discount
      if (isDronePart && discountPrice < price) {
        discountAmount += (price - discountPrice) * item.quantity;
      }
    });

    // Calculate the GST amount (18% of subtotal)
    const gstAmount = subtotal * 0.18;

    // Calculate the 1% platform fee (1% of subtotal after discount)
    const platformFee = (subtotal - discountAmount) * 0.01;

    // Check if the state of the user matches the state of the manufacturer
    const gstLabel = userAddress?.state === manufacturerState ? "GST" : "HGST";

    // Calculate the total amount after applying GST and platform fee
    const total =
      subtotal - discountAmount + gstAmount + platformFee + totalDeliveryFee;

    // Set the state with the calculated values (subtotal, discount, total, GST, platform fee)
    setAmounts({
      ...amounts,
      subtotal: subtotal, // Set the subtotal in the state
      discountAmount: discountAmount, // Set the discount amount in the state
      total: total, // Set the total after applying the discount, GST, and platform fee
      gstAmount: gstAmount, // Store the GST amount for display
      gstLabel: gstLabel, // Store the GST label ('GST' or 'HGST')
      platformFee: platformFee,
      delievery: totalDeliveryFee,
    });
  };

  const handleAddressModalClose = (type) => {
    if (type === 1) {
      setAddAddressData({
        name: "",
        address: "",
        city: "",
        country: "",
        pincode: "",
        state: "",
        phoneNumber: "",
      });
      setIsAddAddressModal(false);
    }
    if (type === 2) {
      setEditAddressData({
        name: "",
        address: "",
        city: "",
        country: "",
        pincode: "",
        state: "",
        phoneNumber: "",
        id: "",
      });
      setIsEditAddressModal(false);
    }
  };

  function formatPrice(amount) {
    if (!amount || amount === 0) {
      return 0;
    }
    amount = parseFloat(amount).toFixed(2);
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return amount;
  }

  const handleOpenEditmodal = (data) => {
    setEditAddressData({
      address: data?.address,
      city: data?.city,
      country: data?.country,
      id: data?._id,
      name: data.name,
      phoneNumber: data?.phoneNumber,
      pincode: data?.pincode,
      state: data?.state,
    });
    setIsEditAddressModal(true);
  };

  // const handleCreateOrder = async () => {
  //   if (!currentAddress?.address?._id) {
  //     return toast.error("Address is required");
  //   }

  //   const data = {
  //     addressId: currentAddress?.address?._id,
  //     paymentType: paymentMethod, // paymentMethod can be "online" or "COD"
  //   };

  //   try {

  //     const response = await createOrder(data);
  //     const ress = await createOrderr(data);

  //     if (response.status === "success" && response.data.redirectURIi) {

  //       window.location.href = response.data.redirectURIi;

  //       return;
  //     }

  //     // If payment is not online (i.e., COD), show success message
  //     toast.success("Order Placed Successfully");
  //     setIsConfirmationPopup("");
  //   } catch (error) {
  //     console.error("Error creating order:", error);
  //     toast.error("Failed to place order. Please try again.");
  //   }
  // };

  // const handleCreateOrder = async () => {
  //   // Ensure an address is provided
  //   if (!currentAddress?.address?._id) {
  //     return toast.error("Address is required");
  //   }

  //   const data = {
  //     addressId: currentAddress?.address?._id,
  //     paymentType: paymentMethod, // "online" or "COD"
  //   };

  //   try {

  //     // Step 1: Call the backend to create the order and get the payment details
  //     const response = await createOrder(data);
  //     const ress = await createOrderr(data);

  //     // Step 2: If the response indicates success and contains a redirectURIi, redirect to payment gateway
  //     if (response.status === "Order created and payment initiated" && response.message.redirectURIi) {

  //       // Debugging: Ensure the redirect is triggered

  //       // Try replacing the window location
  //       window.location.replace(response.message.redirectURIi);

  //       return; // End function here as we are redirecting the user
  //     }

  //     // Step 3: Handle the case for COD or non-online payment
  //     toast.success("Order placed successfully");
  //     setIsConfirmationPopup(""); // Close the confirmation popup if the order is placed

  //   } catch (error) {
  //     console.error("Error creating order:", error);
  //     toast.error("Failed to place order. Please try again.");
  //   }
  // };

  //   const openRazorpayCheckout = (razorpayOrder) => {
  //   if (!window.Razorpay) {
  //     toast.error(
  //       "Razorpay SDK is not loaded"
  //     );
  //     return;
  //   }

  //   const options = {
  //     key: process.env.REACT_APP_RAZORPAY_KEY_ID,

  //     amount: razorpayOrder.amount,

  //     currency: razorpayOrder.currency || "INR",

  //     name: "Drone Planet",

  //     description: "Drone Purchase",

  //     order_id: razorpayOrder.id,

  //     handler: async function (paymentResponse) {
  //       console.log(
  //         "🟢 Razorpay payment response:",
  //         paymentResponse
  //       );

  //       try {
  //         const verifyResponse = await axios.post(
  //           process.env.REACT_APP_API_URL +
  //             "/verifyRazorpayPayment",
  //           {
  //             razorpay_order_id:
  //               paymentResponse.razorpay_order_id,

  //             razorpay_payment_id:
  //               paymentResponse.razorpay_payment_id,

  //             razorpay_signature:
  //               paymentResponse.razorpay_signature,
  //           },
  //           {
  //             headers: {
  //               token: Cookies.get("token"),
  //             },
  //           }
  //         );

  //         console.log(
  //           "🟢 Razorpay verification response:",
  //           verifyResponse.data
  //         );

  //         if (
  //           verifyResponse?.data?.status ===
  //           "success"
  //         ) {
  //           toast.success(
  //             "Payment successful!"
  //           );

  //           dispatch(emptyCartCount());

  //           setIsConfirmationPopup(false);

  //           navigate("/orders");
  //         } else {
  //           toast.error(
  //             verifyResponse?.data?.message ||
  //             "Payment verification failed"
  //           );
  //         }

  //       } catch (error) {
  //         console.error(
  //           "❌ Razorpay verification error:",
  //           error
  //         );

  //         toast.error(
  //           "Payment verification failed"
  //         );
  //       }
  //     },

  //     modal: {
  //       ondismiss: function () {
  //         console.log(
  //           "Razorpay checkout closed"
  //         );
  //       },
  //     },

  //     theme: {
  //       color: "#007bff",
  //     },
  //   };

  //   const razorpay =
  //     new window.Razorpay(options);

  //   razorpay.on(
  //     "payment.failed",
  //     function (response) {
  //       console.error(
  //         "❌ Razorpay payment failed:",
  //         response.error
  //       );

  //       toast.error(
  //         response?.error?.description ||
  //         "Payment failed"
  //       );
  //     }
  //   );

  //   razorpay.open();
  // };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      // Already loaded
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const existingScript = document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]',
      );

      if (existingScript) {
        existingScript.onload = () => resolve(true);

        existingScript.onerror = () => resolve(false);

        return;
      }

      const script = document.createElement("script");

      script.src = "https://checkout.razorpay.com/v1/checkout.js";

      script.async = true;

      script.onload = () => {
        console.log("✅ Razorpay SDK loaded");

        resolve(true);
      };

      script.onerror = () => {
        console.error("❌ Failed to load Razorpay SDK");

        resolve(false);
      };

      document.body.appendChild(script);
    });
  };

  const handleCreateOrder = async () => {
    // ============================================
    // 1. VALIDATE ADDRESS
    // ============================================

    if (!currentAddress?.address?._id) {
      return toast.error("Address is required");
    }

    // ============================================
    // 2. VALIDATE PAYMENT GATEWAY
    // ============================================

    if (!paymentGateway) {
      return toast.error("Please select a payment gateway");
    }

    // ============================================
    // 3. CHECK CART TYPE
    // ============================================

    console.log("drone items : ", allItems);

    const hasDroneParts = allItems.some(
      (item) => item.detail?.type === "dronePart",
    );

    const hasDrones = allItems.some((item) => item.detail?.type === "drone");

    if (hasDroneParts && hasDrones) {
      return toast.error(
        "Drone and drone parts cannot be purchased together. Please checkout separately.",
      );
    }

    // ============================================
    // 4. SELECT CORRECT API
    // ============================================

    const orderApi = hasDroneParts ? createOrderr : createOrder;

    const data = {
      addressId: currentAddress.address._id,
      paymentType: "online",
      paymentGateway,
      amount: total,
    };

    console.log("=================================");
    console.log("🟢 Creating order");
    console.log("🛒 Cart items:", allItems);
    console.log("🔹 Has drone parts:", hasDroneParts);
    console.log("🔹 Has drones:", hasDrones);
    console.log("💳 Payment gateway:", paymentGateway);
    console.log("💰 Amount:", total);
    console.log("📡 API:", hasDroneParts ? "createOrderr" : "createOrder");
    console.log("=================================");

    try {
      // ============================================
      // 5. CALL ONLY ONE ORDER API
      // ============================================

      console.log("=================================");
      console.log("🛒 ALL ITEMS:", allItems);
      console.log(
        "🛒 ITEM TYPES:",
        allItems.map((item) => item.type),
      );
      console.log("🔹 hasDroneParts:", hasDroneParts);
      console.log("🔹 hasDrones:", hasDrones);
      console.log(
        "📡 SELECTED API:",
        hasDroneParts ? "createOrderr" : "createOrder",
      );
      console.log("=================================");

      const orderResponse = await orderApi(data);

      console.log("🟢 FULL CREATE ORDER RESPONSE:", orderResponse);

      // Your backend response helper returns:
      //
      // {
      //   data: "success",
      //   status: "...",
      //   message: {...}
      // }

      if (orderResponse?.data !== "success") {
        console.error("❌ Order creation failed:", orderResponse);

        toast.error(
          orderResponse?.status ||
            orderResponse?.message ||
            "Unable to create order",
        );

        return;
      }

      const paymentData = orderResponse?.message;

      console.log("🟢 PAYMENT DATA:", paymentData);

      // ============================================
      // 6. PHONEPE
      // ============================================

      if (paymentGateway === "phonepe") {
        const redirectURI =
          paymentData?.redirectURI || paymentData?.redirectURIi;

        console.log("🟣 PhonePe Redirect URI:", redirectURI);

        if (!redirectURI) {
          toast.error("PhonePe payment URL not received");

          return;
        }

        window.location.replace(redirectURI);

        return;
      }

      // ============================================
      // 7. RAZORPAY
      // ============================================

      if (paymentGateway === "razorpay") {
        const razorpayLoaded = await loadRazorpayScript();

        if (!razorpayLoaded) {
          toast.error("Unable to load Razorpay. Please try again.");

          return;
        }

        const razorpayOrderId = paymentData?.razorpayOrderId;

        const razorpayKeyId = paymentData?.razorpayKeyId;

        const razorpayAmount = paymentData?.razorpayAmount;

        const razorpayCurrency = paymentData?.razorpayCurrency || "INR";

        console.log("=================================");
        console.log("💳 Razorpay Order ID:", razorpayOrderId);
        console.log("💳 Razorpay Key:", razorpayKeyId);
        console.log("💳 Razorpay Amount:", razorpayAmount);
        console.log("💳 Razorpay Currency:", razorpayCurrency);
        console.log("=================================");

        // Validate Razorpay data
        if (!razorpayOrderId) {
          toast.error("Razorpay Order ID not received");
          return;
        }

        if (!razorpayKeyId) {
          toast.error("Razorpay Key ID not received");
          return;
        }

        if (!razorpayAmount) {
          toast.error("Razorpay amount not received");
          return;
        }

        if (!window.Razorpay) {
          toast.error("Razorpay SDK is not loaded");
          return;
        }

        // ============================================
        // RAZORPAY CHECKOUT OPTIONS
        // ============================================

        const options = {
          key: razorpayKeyId,

          amount: razorpayAmount,

          currency: razorpayCurrency,

          name: "Drone Planet",

          description: hasDroneParts ? "Drone Part Purchase" : "Drone Purchase",

          order_id: razorpayOrderId,

          handler: async function (razorpayResponse) {
            console.log("✅ Razorpay payment successful:", razorpayResponse);

            try {
              // ============================================
              // VERIFY PAYMENT
              // ============================================

              const verifyResponse = await axios.post(
                process.env.REACT_APP_API_URL +
                  "/verifyRazorpayPayment",

                // "http://localhost:6002/verifyRazorpayPayment",
                {
                  razorpay_order_id: razorpayResponse.razorpay_order_id,

                  razorpay_payment_id: razorpayResponse.razorpay_payment_id,

                  razorpay_signature: razorpayResponse.razorpay_signature,
                },
                {
                  headers: {
                    token: Cookies.get("token"),
                  },
                },
              );

              console.log(
                "✅ Razorpay verification response:",
                verifyResponse.data,
              );

              // Your backend helper may return
              // success in data or status.
              const verificationSuccess =
                verifyResponse?.data?.data === "success" ||
                verifyResponse?.data?.status === "success";

              if (verificationSuccess) {
                toast.success("Payment successful!");

                // Clear Redux cart count
                dispatch(emptyCartCount());

                // Close confirmation modal
                setIsConfirmationPopup(false);

                // Go to orders
                navigate("/orders");

                return;
              }

              toast.error(
                verifyResponse?.data?.message || "Payment verification failed",
              );
            } catch (verifyError) {
              console.error("❌ Razorpay verification error:", verifyError);

              toast.error(
                verifyError?.response?.data?.message ||
                  "Payment verification failed",
              );
            }
          },

          modal: {
            ondismiss: function () {
              console.log("⚠️ Razorpay checkout closed");
            },
          },

          theme: {
            color: "#007bff",
          },
        };

        console.log("🟢 Razorpay Checkout Options:", options);

        // ============================================
        // OPEN RAZORPAY
        // ============================================

        const razorpayInstance = new window.Razorpay(options);

        razorpayInstance.on("payment.failed", function (paymentFailure) {
          console.error("❌ Razorpay payment failed:", paymentFailure.error);

          toast.error(
            paymentFailure?.error?.description || "Razorpay payment failed",
          );
        });

        console.log("🚀 Opening Razorpay Checkout...");

        razorpayInstance.open();

        return;
      }

      // ============================================
      // INVALID GATEWAY
      // ============================================

      toast.error("Invalid payment gateway selected");
    } catch (error) {
      console.error("❌ Error creating order:", error);

      toast.error(
        error?.response?.data?.message ||
          "Failed to place order. Please try again.",
      );
    }
  };

  // const handleCreateOrder = async () => {
  //   // Ensure an address is provided
  //   if (!currentAddress?.address?._id) {
  //     return toast.error("Address is required");
  //   }

  //   const data = {
  //     addressId: currentAddress?.address?._id,
  //     paymentType: paymentMethod, // "online" or "COD"
  //   };

  //   try {

  //     // Call createOrder
  //     const response = await createOrder(data);

  //     // Check response for createOrder
  //     if (response.status === "Order created and payment initiated" && response.message?.redirectURIi) {
  //       window.location.replace(response.message.redirectURIi);
  //       return; // End function here as we are redirecting the user
  //     }

  //     // Call createOrderr
  //     const ress = await createOrderr(data);

  //     // Check response for createOrderr
  //     if (ress.status === "Order created and payment initiated" && ress.message?.redirectURIi) {
  //       window.location.replace(ress.message.redirectURIi);
  //       return; // End function here as we are redirecting the user
  //     }

  //     // Handle COD or other non-online payments
  //     toast.success("Order placed successfully");
  //     setIsConfirmationPopup(""); // Close the confirmation popup if the order is placed
  //   } catch (error) {
  //     console.error("Error creating order:", error);
  //     toast.error("Failed to place order. Please try again.");
  //   }
  // };

  useEffect(() => {
    if (token) {
      handleGetAllItems();
      getAllAddress();
    }
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: Smooth scrolling animation
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <div className="">
        <Header />
      </div>
      <div className="">
        <div className="container py-5">
          <h2 className="ff_heebo fw-bold fs_43 clr_dark_blue_2">
            My <span style={{ color: "#328CCD" }}>Cart{""}</span>
            <span className="color_blue_2 fs_10">({allItems?.length})</span>
          </h2>
          <Row className="pb-4">
            <Col xl={9} lg={8}>
              <div className="bg-white p-4 rounded-2 bg-white-border">
                {allItems?.length !== 0 ? (
                  allItems?.map((item, index) => {
                    return (
                      <Row
                        className="border-bottom-row px-2 pb-3 mb-3"
                        key={index}
                      >
                        <Col className="ps-0" md={8} sm={12}>
                          <Row className="align-items-start height-of-products">
                            <Col lg={5} xl={3} md={4} sm={5}>
                              <Link
                                to={`/drone-part-details/${item?.detail?._id}`}
                              >
                                <div className="border-1 border rounded-2 p-1">
                                  <img
                                    className="w-100"
                                    src={item?.detail?.images[0]}
                                    alt="productimage"
                                  />
                                </div>
                              </Link>
                            </Col>
                            <Col
                              className="ps-sm-0 mt-3 mt-sm-0 d-flex flex-column justify-content-between h-100"
                              lg={7}
                              xl={9}
                              md={8}
                              sm={7}
                            >
                              <div>
                                <p className="clr_dark_blue_2 fs_18 fw-medium ff_heebo mb-0 text-truncate">
                                  {item?.detail?.title}
                                </p>
                                <p className="color_darkgray_2 fs_15 ff_heebo mb-0">
                                  {item?.detail?.description.slice(0, 150)}
                                  {item?.detail?.description.length > 150 &&
                                    "..."}
                                </p>
                                <div className="d-flex align-items-center gap-3 mt-2">
                                  <button
                                    className="btn-common-remove-save fw-medium ff_heebo color_red_2 ff_inter fs_12 bg-white py-1 px-2"
                                    onClick={() => handleRemoveItem(item?._id)}
                                  >
                                    Remove
                                  </button>
                                  {/* <button className="btn-common-remove-save fw-medium ff_heebo color_blue_2 ff_inter fs_12 bg-white py-1 px-2">
                                    Save for later
                                  </button> */}
                                </div>
                              </div>
                              <div className="d-md-none flex-column-reverse d-flex gap-1 mt-3">
                                <p className="ff_heebo fw-medium fs_16 clr_dark_blue_2 mb-1">
                                  <span className="fw-bold">₹</span>
                                  {item?.detail?.price}{" "}
                                </p>
                                <div className="">
                                  <select
                                    class="form-select select-div fs_16 me-auto ms-0 clr_dark_blue_2 ff_heebo"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      handleUpdateQuantity(
                                        item?._id,
                                        e.target.value,
                                      )
                                    }
                                    value={item?.quantity}
                                  >
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                  </select>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col className="pe-0 d-none d-md-block" md={4} sm={5}>
                          <div>
                            <p className="ff_heebo fw-medium text-end fs_xxsm clr_dark_blue_2 mb-1">
                              <span className="">
                                ₹{item?.detail?.price}
                              </span>{" "}
                            </p>
                            <div className="w-50 ms-auto">
                              <select
                                className="form-select select-div clr_dark_blue_2 ff_heebo"
                                aria-label="Quantity"
                                onChange={(e) =>
                                  handleUpdateQuantity(
                                    item?._id,
                                    Number(e.target.value),
                                  )
                                }
                                value={item?.quantity}
                              >
                                {Array.from({ length: 100 }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    );
                  })
                ) : (
                  <div className="text-center ff_heebo fs_26">
                    Your cart is empty!
                  </div>
                )}
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div
                    className="d-flex align-items-center gap-2 cursor_pointer"
                    onClick={() => navigate("/drone-parts")}
                  >
                    <img
                      style={{ width: "18px", height1: "18px" }}
                      src={arrowback}
                      alt="backarrow"
                    />
                    <p className="mb-0 color_blue_2 fw-medium">Back to shop</p>
                  </div>
                  <div>
                    {allItems?.length !== 0 && (
                      <button
                        className="ff_inter fs_xxsm color_blue_2 btn-common-remove-save py-1 px-3 bg-white fw-medium"
                        onClick={() => handleRemoveItem(null)}
                      >
                        Remove all
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <p className="text-center ff_inter fs_xxsm mt-3 color_grey_4">
                In case of queries, please call{" "}
                <a
                  href="tel:+919773571992"
                  className="color_blue_2 text-decoration-underline fw-medium"
                >
                  Anushka Singh(+91 97735 71992)
                </a>
              </p>
              <div className="mt-3">
                <Row className="justify-content-center">
                  <Col lg={4} sm={6}>
                    <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
                      <div className="lock-bg-div d-flex align-items-center justify-content-center">
                        <LockIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#007bff",
                          }}
                        />
                      </div>
                      <div>
                        <p className="ff_inter fs_13 clr_dark_blue_2 mb-0">
                          Secure payment
                        </p>
                        <p className="ff_inter fs_13 color_grey_4 mb-0">
                          Fast, secure, and hassle-free checkout!
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col className="mt-3 mt-sm-0" lg={4} sm={6}>
                    <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
                      <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
                        <MessageIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#007bff",
                          }}
                        />
                      </div>
                      <div>
                        <p className="ff_inter fs_13 clr_dark_blue_2 mb-0">
                          Customer Satisfaction
                        </p>
                        <p className="ff_inter fs_13 color_grey_4 mb-0">
                          We’re here to ensure a smooth experience.
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col className="mt-3 mt-lg-0" lg={4} sm={6}>
                    <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
                      <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
                        <LocalShippingIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#007bff",
                          }}
                        />
                      </div>
                      <div>
                        <p className="ff_inter fs_13 clr_dark_blue_2 mb-0">
                          Fast Delivery
                        </p>
                        <p className="ff_inter fs_13 color_grey_4 mb-0">
                          Get your order delivered swiftly and securely.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="mt-5">
                <h2 className="mb-0 fs_24 ff_heebo clr_dark_blue_2 mb-3 fw-bold">
                  Shipping Address
                </h2>
                <div className="addressBox">
                  {allAddress.length !== 0 ? (
                    allAddress.map((item, index) => (
                      <div
                        key={item._id}
                        className="bg-white bg-white-border px-4 py-3 rounded-2 mb-3 w-100 position-relative"
                      >
                        <p className="mb-0 fs-15 color_darkgray_2">
                          Name: {item?.name}
                        </p>
                        <p className="mb-0 fs-15 color_darkgray_2">
                          Address: {item?.address}
                        </p>
                        <p className="mb-0 fs-15 color_darkgray_2">
                          Phone Number: {item?.phoneNumber}
                        </p>
                        <p className="mb-0 fs-15 color_darkgray_2">
                          City: {item.city}
                        </p>
                        <p className="mb-0 fs-15 color_darkgray_2">
                          State: {item.state}
                        </p>
                        <p className="mb-0 fs-15 color_darkgray_2">
                          PIN Code: {item?.pincode}
                        </p>
                        <p className="mb-0 fs-15 color_darkgray_2">
                          Country: {item.country}
                        </p>

                        <div className="d-flex gap-2">
                          <button
                            className="btn-common-remove-save fw-medium ff_heebo color_blue_2 ff_inter fs_12 bg-white py-1 px-2 mt-3"
                            onClick={() => handleOpenEditmodal(item)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn-common-remove-save fw-medium ff_heebo color_red_2 ff_inter fs_12 bg-white py-1 px-2 mt-3"
                            onClick={() => handleRemoveAddress(item?._id)}
                          >
                            Remove
                          </button>
                        </div>

                        <div className="addressCheckbox">
                          <input
                            type="checkbox"
                            checked={currentAddress.index === index} // Only the selected address will be checked
                            onChange={() =>
                              setCurrentAddress({
                                index:
                                  currentAddress.index === index ? null : index, // Deselect if the same address is clicked again
                                address:
                                  currentAddress.index === index ? {} : item,
                              })
                            }
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="bg-white bg-white-border p-4 rounded-2 text-center">
                      No Address Found
                    </div>
                  )}
                </div>

                {token && (
                  <div className="text-end mt-3">
                    <button
                      className="btn-common-remove-save fw-medium ff_heebo color_blue_2 ff_inter fs_12 bg-white py-1 px-2"
                      onClick={() => setIsAddAddressModal(true)}
                    >
                      Add New Address
                    </button>
                  </div>
                )}
              </div>
            </Col>
            <Col className="ps-1 mt-4 mt-lg-0" xl={3} lg={4}>
              <div className="bg-white p-3 rounded-2 bg-white-border">
                <p className="mb-0 ff_inter fs_xxsm clr_dark_grey_6">
                  Have a coupon?
                </p>
                <div className="bg-white-border d-flex align-items-center justify-content-between rounded-2 px-1 mt-2">
                  <input
                    className="border-0 w-100 coupon-input clr_dark_grey_5 fs_xxsm ff_inter py-2 ps-2"
                    placeholder="Add coupon"
                    type="text"
                  />
                  <button className="ff_inter w-50 fs_15 color_blue_2 btn-apply-coupon py-2 bg-white fw-medium">
                    Apply
                  </button>
                </div>
              </div>

              <div className="bg-white p-3 rounded-2 bg-white-border mt-3">
                <div className="d-flex align-items-center justify-content-between">
                  <p className="mb-0 ff_inter fs_xxsm clr_dark_grey_6">
                    Subtotal:
                  </p>
                  <p className="mb-0 ff_inter fs_xxsm clr_dark_grey_6">
                    ₹ {formatPrice(subtotal)}
                  </p>
                </div>

                {/* Display GST or HGST */}

                {allItems.length > 0 && (
                  <>
                    {/* <div className="d-flex align-items-center justify-content-between mt-2">
      <p className="mb-0 ff_inter fs_xxsm clr_dark_grey_6">
        {gstLabel}(18%):
      </p>
      <p className="mb-0 ff_inter fs_xxsm clr_green">
        <span>+</span> <span className="fw-bold">₹</span>
        {formatPrice(gstAmount)}
      </p>
    </div> */}

                    {/* Display Platform Fee */}
                    {/* <div className="d-flex align-items-center justify-content-between mt-2">
      <p className="mb-0 ff_inter fs_xxsm clr_dark_grey_6">
        Platform Fee (1%):
      </p>
      <p className="mb-0 ff_inter fs_xxsm clr_green">
        <span>+</span> <span className="fw-bold">₹</span>
        {formatPrice(platformFee)}
      </p>
    </div> */}

                    {/* <div className="d-flex align-items-center justify-content-between mt-2">
      <p className="mb-0 ff_inter fs_xxsm clr_dark_grey_6">
        Delivery Fee:
      </p>
      <p className="mb-0 ff_inter fs_xxsm clr_green">
        <span>+</span> <span className="fw-bold">₹</span>
        {formatPrice(delievery)}
      </p>
    </div> */}
                  </>
                )}

                <div className="hr-line-div mt-3"></div>

                <div className="d-flex align-items-center justify-content-between flex-column align-items-start">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <p className="mb-0 ff_inter fw-semibold fs_xxsm mt-3 clr_dark_blue_2">
                      Total:
                    </p>
                    <p className="mb-0 ff_inter fw-bold fs_lg mt-3 clr_dark_blue_2">
                      ₹{formatPrice(total)}
                    </p>
                  </div>
                  <p
                    className="mb-0 ff_inter clr_dark_blue_2 mt-1"
                    style={{ fontSize: "13px" }}
                  >
                    * Inclusive of all taxes and delivery fee
                  </p>
                </div>

                <div>
                  {/* <div className="mt-3 d-flex align-items-start gap-2">
        <div className="radio-btn-margin">
          <input
            className="input-radio mt-1"
            type="radio"
            name="paymentMethod"
            checked={paymentMethod === "cash on delivery"}
            onChange={() => setPaymentMethod("cash on delivery")}
          />
        </div>
        <div>
          <p className="ff_inter fs_15 clr_dark_blue mb-0">
            Cash on delivery
          </p>
          <p className="ff_inter fs_12 clr_dark_grey_8 mb-0">
            Pay with cash upon delivery.
          </p>
        </div>
      </div> */}

                  <div className="mt-3">
                    <p className="ff_inter fs_15 clr_dark_blue_2 mb-2 fw-semibold">
                      Select Payment Method
                    </p>

                    {/* PHONEPE */}
                    {/* <div
                      className="d-flex align-items-start gap-2 border rounded-2 p-3 mb-2"
                      style={{
                        cursor: "pointer",
                        border:
                          paymentGateway === "phonepe"
                            ? "2px solid #007bff"
                            : "1px solid #ddd",
                      }}
                      onClick={() => {
                        setPaymentMethod("online");
                        setPaymentGateway("phonepe");
                      }}
                    >
                      <input
                        className="input-radio mt-1"
                        type="radio"
                        name="paymentGateway"
                        checked={paymentGateway === "phonepe"}
                        onChange={() => {
                          setPaymentMethod("online");
                          setPaymentGateway("phonepe");
                        }}
                      />

                      <div>
                        <p className="ff_inter fs_15 clr_dark_blue_2 mb-1">
                          PhonePe
                        </p>

                        <img
                          className="phonepay"
                          src={phonepay}
                          alt="PhonePe"
                          style={{
                            width: "100px",
                            height: "45px",
                            objectFit: "contain",
                          }}
                        />

                        <p className="ff_inter fs_12 clr_dark_grey_8 mb-0">
                          Pay securely through PhonePe.
                        </p>
                      </div>
                    </div> */}

                    {/* RAZORPAY */}
                    <div
  className="d-flex align-items-center gap-3 rounded-3 p-3"
  style={{
    cursor: "pointer",
    position: "relative",
    background:
      paymentGateway === "razorpay"
        ? "linear-gradient(135deg, #f7fbff 0%, #eef6ff 100%)"
        : "#fff",
    border:
      paymentGateway === "razorpay"
        ? "1.5px solid #007bff"
        : "1px solid #e5e7eb",
    boxShadow:
      paymentGateway === "razorpay"
        ? "0 4px 14px rgba(0, 123, 255, 0.12)"
        : "0 2px 8px rgba(0, 0, 0, 0.04)",
    transition: "all 0.2s ease",
  }}
  onClick={() => {
    setPaymentMethod("online");
    setPaymentGateway("razorpay");
  }}
>
  {/* Razorpay Logo */}
  <div
    className="d-flex align-items-center justify-content-center rounded-2"
    style={{
      width: "72px",
      height: "52px",
      background: "#fff",
      border: "1px solid #eef0f3",
      flexShrink: 0,
    }}
  >
    <img
      src={razorpay}
      alt="Razorpay"
      style={{
        width: "62px",
        height: "40px",
        objectFit: "contain",
      }}
    />
  </div>

  {/* Payment Details */}
  <div className="flex-grow-1">
    <div className="d-flex align-items-center gap-2 mb-1">
      <p
        className="ff_inter mb-0"
        style={{
          fontSize: "15px",
          fontWeight: 600,
          color: "#1f2937",
        }}
      >
        Razorpay
      </p>

      <span
        style={{
          fontSize: "10px",
          fontWeight: 600,
          color: "#007bff",
          background: "#eaf4ff",
          padding: "3px 7px",
          borderRadius: "20px",
        }}
      >
        SECURE
      </span>
    </div>

    <p
      className="ff_inter mb-0"
      style={{
        fontSize: "12px",
        color: "#6b7280",
      }}
    >
      Cards, UPI, Net Banking & more
    </p>
  </div>

</div>
                  </div>

                  {/* <div className="mt-3 d-flex align-items-start gap-2">
        <input className="input-checkbox mt-1" type="checkbox" />
        <label className="ff_inter fs_12 clr_dark_blue" htmlFor="ship">
          I would like to receive exclusive emails with discounts and product information
        </label>
      </div> */}
                </div>

                <button
                  style={{
                    height: "53px",
                    backgroundColor:
                      !token || allItems.length === 0 ? "gray" : "#007bff", // Change to gray when disabled
                    cursor:
                      !token || allItems.length === 0
                        ? "not-allowed"
                        : "pointer",
                    border: "none", // Ensure no unwanted borders
                  }}
                  className="text-white ff_inter fs_sm fw-medium w-100 rounded-2 mt-3"
                  disabled={!token || allItems.length === 0} // Ensure paymentMethod is selected
                  onClick={() => {
                    setIsConfirmationPopup(true);
                  }}
                >
                  Checkout
                </button>

                <div className="d-flex align-items-center justify-content-lg-between justify-content-center gap-1 mt-3">
                  <img
                    className="payment-images"
                    src={americanexpress}
                    alt="americanexpress"
                  />
                  <img className="payment-images" src={debit} alt="debit" />
                  <img className="payment-images" src={paypal} alt="paypal" />
                  <img className="payment-images" src={visa} alt="visa" />
                  <img
                    className="payment-images"
                    src={applepay}
                    alt="applepay"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <AddressModal
        onHide={() => handleAddressModalClose(1)}
        show={isAddAddressModal}
        title={"Add Address"}
        data={addAddressData}
        onchange={(e) => handleAddressChange(1, e)}
        onSubmit={handleAddAddress}
        buttonTitle={"Add"}
      />

      <AddressModal
        onHide={() => handleAddressModalClose(2)}
        show={isEditAddressModal}
        title={"Edit Address"}
        data={editAddressData}
        onchange={(e) => handleAddressChange(2, e)}
        onSubmit={handleEditAddress}
        buttonTitle={"Update"}
      />
      <ConfirmationModal
        onHide={() => setIsConfirmationPopup(false)}
        show={isConfirmationPopup}
        text={"Are you sure you want to purchase these items?"}
        onConfirm={handleCreateOrder}
      />
      <Footer />
    </>
  );
};

export default Cart;
